import type { NnInterval } from './types';

export const computeRmssdFromNn = (intervals: NnInterval[]): number => {
  if (intervals.length <= 1) return 0;

  const squaredDiffs: number[] = [];
  for (let index = 1; index < intervals.length; index += 1) {
    const diff = intervals[index].rrMs - intervals[index - 1].rrMs;
    squaredDiffs.push(diff * diff);
  }

  const meanSquared =
    squaredDiffs.reduce((sum, value) => sum + value, 0) / squaredDiffs.length;

  return Math.sqrt(meanSquared);
};
